export const configMotorPower = (action) => ["/config/motor", action, "std_msgs/String"];
export const configHeight = (height) => ["/config/height", height, "std_msgs/Float32"];
export const configMode = (mode) => ["/config/mode", mode, "std_msgs/String"];

const LINEAR_Y_DEADZONE = 0.25;

/** Hard-zero below deadzone; remap [deadzone, 1] → [0, 1] (signed). */
const applyDeadzoneRemap = (value, deadzone) => {
    const magnitude = Math.abs(value);
    if (magnitude < deadzone) return 0;
    const max = 1;
    if (deadzone >= max) return 0;
    const remapped = (magnitude - deadzone) / (max - deadzone);
    return Math.sign(value) * Math.min(1, remapped);
};

export const performMovement = ({ x = 0, y = 0, z = 0, speedMultiplier = 1.0 }) => {
    const linearY = applyDeadzoneRemap(0 - x, LINEAR_Y_DEADZONE) * speedMultiplier;

    return [
        "/perform/movement",
        {
            linear: {
                x: y * speedMultiplier,
                y: linearY,
                z: 0 * speedMultiplier,
            },
            angular: {
                x: 0,
                y: 0,
                z: (0 - z) * speedMultiplier,
            },
        },
        "geometry_msgs/Twist",
    ]
};
